import * as Yup from "yup";
import { getBlockedTextWarning } from "../../../../core/constants/constants";

export interface EditProfileFormValues {
	gender: string;
	sexualOrientation: string;
	lookingFor: string[];
	status: string;
	bio?: string;
	interest?: string[];
}

const buildBlockedTextTest = (field: string) =>
	function (this: Yup.TestContext, value?: string) {
		if (!value || value.trim().length === 0) return true;
		const blockedReason = getBlockedTextWarning(value, field);
		if (!blockedReason) return true;
		return this.createError({ message: blockedReason });
	};

export const editprofileValidationSchema = Yup.object({
	gender: Yup.string().required("Gender is required"),
	sexualOrientation: Yup.string().required("Sexual orientation is required"),
	lookingFor: Yup.array().of(Yup.string()).min(1, "Select at least one").required("Looking for is required"),
	status: Yup.string().required("Status is required"),
	bio: Yup.string()
		.max(1000, "Description cannot exceed 1000 characters")
		.test("blocked-bio", "", buildBlockedTextTest("Description")),
	interest: Yup.array().of(
		Yup.string()
			.max(50, "Interest cannot exceed 50 characters")
			.test("blocked-interest", "", buildBlockedTextTest("Interest"))
	),
});
